/**
 * tdesign v0.44.2
 * (c) 2022 tdesign
 * @license MIT
 */

var popupDefaultProps = {
  attach: "body",
  destroyOnClose: false,
  hideEmptyPopup: false,
  placement: "top",
  showArrow: false,
  trigger: "hover"
};

export { popupDefaultProps };
//# sourceMappingURL=defaultProps.js.map
